var React = require('react');

function Generic (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("linearGradient",{"id":"a","x1":"60.398%","x2":"0%","y1":"0%","y2":"119.641%"},[React.createElement("stop",{"offset":"0%","stopColor":"#13B2E8","key":0}),React.createElement("stop",{"offset":"100%","stopColor":"#00548F","key":1})])),React.createElement("path",{"fill":"none","fillRule":"evenodd","stroke":"url(#a)","strokeWidth":"3","d":"M3.5 3.5h25v25h-25z","transform":"translate(-2 -2)","key":1})]);
}

Generic.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28"};

module.exports = Generic;

Generic.default = Generic;
